export default{
  eventoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  boardColumnId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  data: {
    value: null,
    required: true,
    state: null
  },
  horario: {
    value: null,
    options: [
      { value: '00:00', text: '00:00' },
      { value: '01:00', text: '01:00' },
      { value: '02:00', text: '02:00' },
      { value: '03:00', text: '03:00' },
      { value: '04:00', text: '04:00' },
      { value: '05:00', text: '05:00' },
      { value: '06:00', text: '06:00' },
      { value: '07:00', text: '07:00' },
      { value: '08:00', text: '08:00' },
      { value: '09:00', text: '09:00' },
      { value: '10:00', text: '10:00' },
      { value: '11:00', text: '11:00' },
      { value: '12:00', text: '12:00' },
      { value: '13:00', text: '13:00' },
      { value: '14:00', text: '14:00' },
      { value: '15:00', text: '15:00' },
      { value: '16:00', text: '16:00' },
      { value: '17:00', text: '17:00' },
      { value: '18:00', text: '18:00' },
      { value: '19:00', text: '19:00' },
      { value: '20:00', text: '20:00' },
      { value: '21:00', text: '21:00' },
      { value: '22:00', text: '22:00' },
      { value: '23:00', text: '23:00' }
    ],
    required: false,
    state: null,
    placeholder: 'Selecione',
    size: 'sm'
  },
  detalhes: {
    value: '',
    maxlength: '280',
    rows: 3,
    minRows: 3,
    maxRows: 12,
    required: true,
    state: null,
    noResize: false
  },
  kmInicial: {
    value: null,
    required: false,
    state: null
  },
  kmFinal: {
    value: null,
    required: false,
    state: null
  },
  selectedUserId: {
    value: null,
    required: false,
    state: null
  },
  selectedUserEmail: {
    value: '',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/followup/followup-form.js